// src/Dashboard/pages/user/CalendarEvents/components/CalendarEventsEmptyState.jsx

import React from "react";
import { FaCalendarAlt, FaTimes } from "react-icons/fa";

export default function CalendarEventsEmptyState({ favoriteOnly, onReset }) {
  return (
    <div className="mt-5 rounded-[24px] border border-dashed border-slate-300 bg-slate-50 px-5 py-12 text-center dark:border-slate-700 dark:bg-slate-800/40">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-white text-slate-400 shadow-sm ring-1 ring-slate-200 dark:bg-slate-900 dark:ring-slate-700">
        <FaCalendarAlt className="text-2xl" />
      </div>

      <h3 className="mt-5 text-lg font-bold text-slate-900 dark:text-white">
        Aucun événement trouvé
      </h3>

      <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-slate-500 dark:text-slate-400">
        {favoriteOnly
          ? "Aucun événement favori ne correspond aux filtres sélectionnés."
          : "Aucun événement ne correspond aux filtres sélectionnés."}
      </p>

      <button
        type="button"
        onClick={onReset}
        className="mt-5 inline-flex items-center gap-2 rounded-2xl bg-slate-900 px-4 py-3 text-sm font-bold text-white transition hover:bg-slate-800 dark:bg-white dark:text-slate-900 dark:hover:bg-slate-100"
      >
        <FaTimes />
        Réinitialiser
      </button>
    </div>
  );
}